module.exports = __webpack_public_path__ + "img/825C4D_A08175_97746C_613B2F-256px.7fd3de01.png";